import React from 'react';
import {twMerge} from 'tailwind-merge';

import {CloseButton} from './CloseButton';

export const SettingsContentWrapper = ({
  header,
  description,
  title,
  children,
}: {
  header: React.ReactNode;
  description?: string;
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <div className={twMerge('flex flex-col', 'gap-8 py-16')}>
      <div
        className={twMerge(
          'flex items-center justify-between',
          'px-20',
          'gap-8'
        )}>
        {header}
        <CloseButton />
      </div>
      <div className={twMerge('px-24')}>
        <div className="mb-16">
          <h1 className={twMerge('text-xl font-semibold leading-[40px]')}>
            {title}
          </h1>
          {description && (
            <p className={twMerge('text-base leading-[140%] text-moon-500')}>
              {description}
            </p>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};
